import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Container, Reveal, useCollection } from "@/components/common";
import PageHero from "@/components/PageHero";
import { getContent } from "@/lib/api";

export default function Insights() {
  const { data } = useCollection(() => getContent("insights"), []);
  const [cat, setCat] = useState("All");
  const cats = ["All", ...Array.from(new Set(data.map((a) => a.category).filter(Boolean)))];
  const shown = cat === "All" ? data : data.filter((a) => a.category === cat);

  return (
    <div data-testid="insights-page">
      <PageHero label="Insights" title="Dr. Sirohi's Insights"
        intro="Perspectives on oncology, cancer research, prevention, health equity, medical education and community health."
        image="https://images.unsplash.com/photo-1781746875712-fb3473667251?crop=entropy&cs=srgb&fm=jpg" />
      <section className="bg-white py-16">
        <Container>
          <div className="mb-10 flex flex-wrap gap-2">
            {cats.map((c) => (
              <button key={c} data-testid={`insights-filter-${c}`} onClick={() => setCat(c)}
                className={`rounded-full border px-4 py-1.5 text-xs font-medium transition-colors ${cat === c ? "border-navy bg-navy text-white" : "border-slate-300 text-navy/70 hover:border-gold"}`}>{c}</button>
            ))}
          </div>
          {shown.length === 0 ? <p className="py-16 text-center text-softgrey-600">No articles yet.</p> : (
            <div className="grid gap-8 md:grid-cols-3">
              {shown.map((a, i) => (
                <Reveal key={a.id} delay={(i % 3) * 0.06}>
                  <Link to={`/insights/${a.slug}`} data-testid={`insight-card-${a.slug}`} className="group flex h-full flex-col overflow-hidden rounded-lg border border-slate-200 bg-white transition-transform duration-200 hover:-translate-y-1">
                    {a.cover_image && <div className="aspect-[16/10] overflow-hidden"><img src={a.cover_image} alt={a.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" /></div>}
                    <div className="flex flex-1 flex-col p-6">
                      <div className="overline text-gold-dark">{a.category}</div>
                      <h3 className="mt-3 flex-1 font-serif text-2xl leading-snug text-navy">{a.title}</h3>
                      <p className="mt-2 line-clamp-2 text-sm text-softgrey-600">{a.excerpt}</p>
                      <div className="mt-4 text-xs text-softgrey-400">{a.author} · {a.reading_time}</div>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </Container>
      </section>
    </div>
  );
}
